<shortcut-menu [subscription]="subscription()" [isTerminated]="isTerminated()">
  <tickets-item [messages]="activities()" />
  <hive-item [subscription]="subscription()" />
</shortcut-menu>
